import ContentLoader from 'react-content-loader';

const skeletonColors = {
  foreground: '#CED8F3',
  background: '#E7ECF5',
};

type Props = {
  variant: 'member' | 'invitation';
};

const ManageAccessSkeleton = ({ variant }: Props) => {
  if (variant === 'member') {
    return (
      <ContentLoader
        width={160}
        height={16}
        viewBox="0 0 160 16"
        foregroundColor={skeletonColors.foreground}
        backgroundColor={skeletonColors.background}
      >
        <rect x="0" y="0" width="160" height="16" rx="8" />
      </ContentLoader>
    );
  }

  return (
    <div className="mb-4 flex items-center justify-between">
      <div className="flex items-center">
        <ContentLoader
          className="mr-3"
          width={32}
          height={32}
          viewBox="0 0 32 32"
          foregroundColor={skeletonColors.foreground}
          backgroundColor={skeletonColors.background}
        >
          <rect x="0" y="0" width="32" height="32" rx="16" />
        </ContentLoader>
        <div className="flex flex-col">
          <ContentLoader
            width={160}
            height={14}
            viewBox="0 0 160 14"
            foregroundColor={skeletonColors.foreground}
            backgroundColor={skeletonColors.background}
          >
            <rect x="0" y="0" width="160" height="14" rx="7" />
          </ContentLoader>
          <ContentLoader
            className="mt-1"
            width={110}
            height={12}
            viewBox="0 0 110 12"
            foregroundColor={skeletonColors.foreground}
            backgroundColor={skeletonColors.background}
          >
            <rect x="0" y="0" width="110" height="12" rx="6" />
          </ContentLoader>
        </div>
      </div>
      <ContentLoader
        width={70}
        height={14}
        viewBox="0 0 70 14"
        foregroundColor={skeletonColors.foreground}
        backgroundColor={skeletonColors.background}
      >
        <rect x="0" y="0" width="70" height="14" rx="7" />
      </ContentLoader>
    </div>
  );
};

export default ManageAccessSkeleton;
